// Wait for lazy collapse content and its opening animation before positioning.
export function scrollToTarget(getTarget, onScrolled = () => {}) {
  let frame;
  let previousTop;
  let stableFrames = 0;
  const started = performance.now();
  const check = now => {
    const target = getTarget();
    const rect = target?.getBoundingClientRect();
    const visible = rect && rect.height > 0 && target.getClientRects().length > 0;
    if (visible) {
      stableFrames = Math.abs(rect.top - previousTop) < 1 ? stableFrames + 1 : 0;
      previousTop = rect.top;
      if ((now - started >= 350 && stableFrames >= 3) || now - started >= 2000) {
        target.scrollIntoView({ behavior: "instant", block: "start" });
        onScrolled();
        return;
      }
    }
    if (now - started < 2500) frame = requestAnimationFrame(check);
  };
  frame = requestAnimationFrame(check);
  return () => cancelAnimationFrame(frame);
}
